import { login, getmenu } from "@/api/user";
import { getInfo } from "@/api/common";
import { getToken, setToken, removeToken } from "@/utils/auth";
import router, { resetRouter } from "@/router";

const state = {
    token: getToken(),
    name: "",
    avatar: "",
    menus: [],
    introduction: "",
    zsname: "",
    roles: [],
    selectRole: "",
    btnroles: [],
    roleList: []
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token;
        // sessionStorage.setItem("token", token);
    },
    SET_INTRODUCTION: (state, introduction) => {
        state.introduction = introduction;
    },
    SET_NAME: (state, name) => {
        state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles;
    },
    SET_SELECTROLE: (state, selectRole) => {
        state.selectRole = selectRole;
    },
    SET_EMAIL: (state, email) => {
        state.email = email;
    },
    SET_ZSNAME: (state, zsname) => {
        state.zsname = zsname;
    },
    SET_USERROLE: (state, userrole) => {
        state.userrole = userrole;
    },
    SET_USERINFOID: (state, userInfoId) => {
        state.userInfoId = userInfoId;
    },
    SET_ROLELIST: (state, roleList) => {
        state.roleList = roleList;
    },
    SET_MENUS: (state, menus) => {
        state.menus = menus;
    },
    SET_BTNROLES: (state, btnroles) => {
        state.btnroles = btnroles;
    },
    SET_KEEPALIVEMENU: (state, keepalivemenu) => {
        state.keepalivemenu = keepalivemenu;
    },
    SET_DEPARTMENT: (state, department) => {
        state.department = department;
    },
    SET_ENTERPRISE: (state, enterprise) => {
        state.enterprise = enterprise;
    },
    SET_USERID: (state, userid) => {
        state.userid = userid;
    }
};

const actions = {
    // user login
    login({ commit }, userInfo) {
        const { account, password } = userInfo;
        return new Promise((resolve, reject) => {
            login({ username: account.trim(), password: password })
                .then(response => {
                    commit("SET_NAME", account);
                    // commit("SET_USERROLE", response.userRole);
                    commit("SET_TOKEN", response.token);
                    setToken(response.token);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // get user info
    getInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            getInfo()
                .then(response => {
                    const { data } = response;
                    if (!data) {
                        reject("获取用户信息失败,请重新登录.");
                    }
                    commit("SET_ZSNAME", data.name);
                    commit("SET_USERROLE", data.userRole);
                    commit("SET_USERID", data.id);

                    commit(
                        "SET_AVATAR",
                        "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif"
                    );
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    getmenu({ commit, state }) {
        return new Promise((resolve, reject) => {
            getmenu()
                .then(response => {
                    const { data } = response;
                    commit("SET_MENUS", data.menuList || []);
                    commit("SET_BTNROLES", data.btnroles || []);
                    commit("SET_KEEPALIVEMENU", data.keepAliveMenuList || []);
                    // commit("SET_DEPARTMENT", data.departmentName);
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // user logout
    logout({ commit, state, dispatch }) {
        commit("SET_TOKEN", "");
        commit("SET_ROLES", []);
        commit("SET_ZSNAME", "");
        commit("SET_BTNROLES", []);
        commit("SET_KEEPALIVEMENU", []);
        commit("SET_DEPARTMENT", {});
        commit("SET_USERINFOID", "");
        removeToken();
        resetRouter();
    },

    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit("SET_TOKEN", "");
            commit("SET_ROLES", []);
            removeToken();
            resolve();
        });
    },

    // dynamically modify permissions
    async changeRoles({ commit, dispatch }, role) {
        const token = role + "-token";

        commit("SET_TOKEN", token);
        setToken(token);

        const { roles } = await dispatch("getInfo");

        resetRouter();

        // generate accessible routes map based on roles
        const accessRoutes = await dispatch("permission/generateRoutes", roles, {
            root: true
        });
        // dynamically add accessible routes
        router.addRoutes(accessRoutes);

        // reset visited views and cached views
        dispatch("tagsView/delAllViews", null, { root: true });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
